import { useEffect, useRef, useState } from "react";
import {
    GetASD,
    GroupByForeignKey,
    GroupByPropCheck,
    GroupByProps,
} from "../../Finanzas/Actions/GetContainer";
import { EjercicioByRange } from "../../Finanzas/Helper/EjercicioByRange";
import { Mes } from "../../Finanzas/Helper/Mes";
import StorageIcon from "@mui/icons-material/Storage";
import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from "@mui/icons-material/FilterList";
import SortIcon from "@mui/icons-material/Sort";
import TuneIcon from "@mui/icons-material/Tune";
import { LoaderScreen } from "../../components/LoaderScreen";
import Swal from "sweetalert2";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

export const FiltroCumplimientoCondicionadasDetalle = ({
    children,
    onBoxChange,
    boxState,
    BoxClick,
    titulo_filtro,
    titulo = "",
    subtitulo = "",
    mostraradr = true,
    mostrarsucursal = true,
    mostrardepartamento = false,
    cargarfiltros = true,
}) => {
    const [stateError, setError] = useState("");

    const fechaActual = new Date();
    const ejercicioActual = fechaActual.getFullYear();
    const mesActual = fechaActual.getMonth() + 1;
    const [state, setstate] = useState({
        data: [],
        adr: [],
        sucursal: [],
        departamento: [],
        periodo: [],
        ejercicioinicio: ejercicioActual,
        periodoinicio: "1",
        ejerciciofin: ejercicioActual,
        periodofin: mesActual,
        tsucursal: "",
        tdeptos: "",
    });
    const {
        data,
        adr,
        periodo,
        sucursal,
        departamento,
        ejercicioinicio,
        periodoinicio,
        ejerciciofin,
        periodofin,
    } = state;
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [Meses, setMeses] = useState([
        { idMes: 1, nombre: 'Enero', checked: false },
        { idMes: 2, nombre: 'Febrero', checked: false },
        { idMes: 3, nombre: 'Marzo', checked: false },
        { idMes: 4, nombre: 'Abril', checked: false },
        { idMes: 5, nombre: 'Mayo', checked: false },
        { idMes: 6, nombre: 'Junio', checked: false },
        { idMes: 7, nombre: 'Julio', checked: false },
        { idMes: 8, nombre: 'Agosto', checked: false },
        { idMes: 9, nombre: 'Septiembre', checked: false },
        { idMes: 10, nombre: 'Octubre', checked: false },
        { idMes: 11, nombre: 'Noviembre', checked: false },
        { idMes: 12, nombre: 'Diciembre', checked: false },
    ]);


    useEffect(() => {
        onClose();
        if (cargarfiltros)
            GetASD()
                .then((res) => {
                    setstate({
                        ...state,
                        data: res,
                    });
                    onBoxChange("pv", {
                        adr: GroupByProps(res, ["idadr", "adr"]),
                        sucursal: [],
                        departamento: [],
                    });
                    onBoxChange("pk", {
                        periodo: []
                    });
                })
                .catch((err) => console.log(err));
    }, []);

    useEffect(() => {
        var newadr = GroupByPropCheck(data, ["idadr", "adr"]);
        var newsucursal = GroupByPropCheck(data, ["idsucursal", "sucursal"], false);
        var newdepartamento = GroupByPropCheck(
            data,
            ["iddepartamento", "departamento"],
            false
        );
        setstate({
            ...state,
            adr: newadr,
            sucursal: newsucursal,
            departamento: newdepartamento,
        });
    }, [data]);
    const onChange = ({ target }) => {
        setstate({
            ...state,
            [target.name]: target.value,
        });
        onBoxChange(target.name, target.value);
    };
    const labelclick = ({ target }) => {
        target.parentNode.firstChild.click();
    };



    const selectedClick = ({ target }, index) => {
        switch (target.name) {
            case "chk-adr":
                var newarray = adr;
                newarray[index].checked = target.checked;

                var newarrarsucursal = [];
                var newarraydepartamento = [];
                var adrActive = [];
                newarray.forEach((item) => {
                    if (item.checked) {
                        adrActive = [...adrActive, { idadr: item.idadr, adr: item.adr }];
                        newarrarsucursal = newarrarsucursal.concat(
                            GroupByForeignKey(data, "idadr", item.idadr, [
                                "idsucursal",
                                "sucursal",
                            ])
                        );
                        newarraydepartamento = newarraydepartamento.concat(
                            GroupByForeignKey(data, "idadr", item.idadr, [
                                "iddepartamento",
                                "departamento",
                            ])
                        );
                    }
                });
                onBoxChange("pv", {
                    adr: adrActive,
                    sucursal: [],
                    departamento: [],
                });
                setstate({
                    ...state,
                    adr: newarray,
                    sucursal:
                        newarrarsucursal.length == 0
                            ? GroupByPropCheck(data, ["idsucursal", "sucursal"], false)
                            : GroupByPropCheck(
                                newarrarsucursal,
                                ["idsucursal", "sucursal"],
                                false
                            ),
                    departamento:
                        newarraydepartamento.length == 0
                            ? GroupByPropCheck(
                                data,
                                ["iddepartamento", "departamento"],
                                false
                            )
                            : GroupByPropCheck(
                                newarraydepartamento,
                                ["iddepartamento", "departamento"],
                                false
                            ),
                });
                break;
            case "chk-sucursal":
                var newarray = sucursal;
                newarray[index].checked = target.checked;

                var newarraydepartamento = [];
                var sucursalactiva = [];
                newarray.forEach((item) => {
                    if (item.checked) {
                        sucursalactiva = [
                            ...sucursalactiva,
                            { idsucursal: item.idsucursal, sucursal: item.sucursal },
                        ];
                        newarraydepartamento = newarraydepartamento.concat(
                            GroupByForeignKey(data, "idsucursal", item.idsucursal, [
                                "iddepartamento",
                                "departamento",
                            ])
                        );
                    }
                });
                onBoxChange("pv", {
                    adr: boxState.pv.adr,
                    sucursal: sucursalactiva,
                    departamento: [],
                });
                setstate({
                    ...state,
                    sucursal: newarray,
                    departamento:
                        newarraydepartamento.length == 0
                            ? GroupByPropCheck(
                                data,
                                ["iddepartamento", "departamento"],
                                false
                            )
                            : GroupByPropCheck(
                                newarraydepartamento,
                                ["iddepartamento", "departamento"],
                                false
                            ),
                });
                break;
            case "chk-periodo":
                // Actualizamos el estado de forma inmutable
                setMeses(prevMeses => {
                    const newMeses = prevMeses.map((item, i) =>
                        i === index ? { ...item, checked: target.checked } : item
                    );

                    // Generar el array de meses activos
                    const periodoActive = newMeses.filter(item => item.checked).map(item => ({
                        idMes: item.idMes,
                        nombre: item.nombre
                    }));

                    // Llamar a onBoxChange con el array de meses activos
                    onBoxChange("pk", {
                        periodo: periodoActive,
                    });

                    return newMeses; // Retornar el nuevo array de meses
                });
                break;
            default:
                var newarray = departamento;
                var departamentoactivo = [];
                newarray[index].checked = target.checked;

                newarray.forEach((item) => {
                    if (item.checked) {
                        departamentoactivo = [
                            ...departamentoactivo,
                            {
                                iddepartamento: item.iddepartamento,
                                departamento: item.departamento,
                            },
                        ];
                    }
                });
                onBoxChange("pv", {
                    adr: boxState.pv.adr,
                    sucursal: boxState.pv.sucursal,
                    departamento: departamentoactivo,
                });
                setstate({
                    ...state,
                    departamento: newarray,
                });
                break;
        }
    };
    const onClick = () => {
        const element = document.getElementById("box-structure-bussiness-filtros-condicionadas");
        if (element != undefined && element != null) {
            element.style.display = "flex";
        }
    };
    const onClose = () => {
        const element = document.getElementById("box-structure-bussiness-filtros-condicionadas");
        if (element != undefined && element != null) {
            element.style.display = "none";
        }
        closeConsulta();
    };
    const closeConsulta = () => { };
    const consultar = () => {
        setLoader({ ...loader, mostrar: true });
        BoxClick()
            .then(() => {
                var tituloSucursal = "";
                var tituloDeptos = "";
                if (boxState.pv.sucursal != undefined && boxState.pv.sucursal != null) {
                    if (boxState.pv.sucursal.length == 0) {
                        if (boxState.pv.adr.length == 1) {
                            tituloSucursal = `Region ${boxState.pv.adr[0].adr},`;
                        } else {
                            tituloSucursal = `TODO EL GRUPO,`;
                        }
                    } else {
                        boxState.pv.sucursal.forEach((item) => {
                            tituloSucursal += `${item.idsucursal}-${item.sucursal}${","} `;
                        });
                    }
                }

                if (
                    boxState.pv.departamento != undefined &&
                    boxState.pv.departamento != null
                ) {
                    if (boxState.pv.departamento.length == 0) {
                        tituloDeptos = "TODOS LOS DEPARTAMENTOS,";
                    } else {
                        boxState.pv.departamento.forEach((item) => {
                            tituloDeptos += `${item.iddepartamento}-${item.departamento
                                }${","} `;
                        });
                    }
                }
                setstate({
                    ...state,
                    tsucursal: tituloSucursal.substr(0, tituloSucursal.length - 1),
                    tdeptos: tituloDeptos.substr(0, tituloDeptos.length - 1),
                });
                setLoader({ ...loader, mostrar: false });
                onClose();
            })
            .catch((err) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("ANALISIS FINANCIERO", JSON.stringify(err), "error");
            });
    };
    const GetChildren = (key) => {
        if (children === undefined || children === null) return <></>;
        if (Array.isArray(children)) {
            var result = children.filter((x) => x.key === key);
            if (result !== undefined && result !== null && result.length > 0) {
                return result[0];
            }
        }
        if (children.key === key) return children;

        return <></>;
    };

    const capitalizeWords = (str) => {
        return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
    };
    return (
        <>
            <LoaderScreen loader={loader} />
            <div className="plantilla-screen-filtro-A">
                <div>
                    <div className="plantilla-screen-filtro-button-modal-A" onClick={onClick}>
                        {/* <button className="boton-box-structure" > */}
                        <FilterAltIcon />
                        Filtrar

                        {/* <header>
                            <div className="titulo">{titulo}</div>
                            <div className="sub-titulo">{subtitulo}</div>
                        </header> */}
                    </div>
                </div>
                {GetChildren("box-actions")}
            </div>
            <div
                id="box-structure-bussiness-filtros-condicionadas"
                key="box-structure-bussiness-filtros"
            >
                <div className="filtro-soy-el-titulo">
                    <div className="filtro-soy-el-titulo-header">
                        {titulo_filtro}
                        <span className="filtro-soy-span-close" onClick={onClose}>
                            X
                        </span>
                    </div>
                    <div className="filtro-soy-el-titulo-line">
                        <div className="filtro-soy-el-titulo-line-bl"></div>
                        <div className="filtro-soy-el-titulo-line-circle"></div>
                        <div className="filtro-soy-el-titulo-line-br"></div>
                    </div>
                </div>
                <div className="box-action-container-filtros">
                    <div className="filtro-tiempo-tipo">
                        <div className="filtro-group">
                            <label>Ejercicio</label>
                            <EjercicioByRange
                                name="ejercicioinicio"
                                value={ejercicioinicio}
                                onChange={onChange}
                            />
                        </div>
                        {/* <div className="filtro-group">
                            <label>Periodo</label>
                            <Mes
                                name="periodoinicio"
                                value={periodoinicio}
                                onChange={onChange}
                            />
                        </div> */}
                        {GetChildren("box-filtro")}

                        <div className="box-filtros-container-buttons">
                            {/* <button className="button-cancel" onClick={onClose}>
                Cancelar
              </button> */}
                            <button className="button-accept" onClick={consultar}>
                                <FilterListIcon /> Cargar
                            </button>
                        </div>
                    </div>
                    {cargarfiltros === false || mostraradr === false ? (
                        <div></div>
                    ) : (
                        <div className="filtro-adr">
                            <div className="title title-adr">Región</div>
                            {adr.map((item, index) => (
                                <div key={`${item}-${index}`} className="chk-groups">
                                    <input
                                        type="checkbox"
                                        name="chk-adr"
                                        onChange={(e) => selectedClick(e, index)}
                                        checked={item.checked}
                                        value={item.idadr}
                                    />
                                    <label>{capitalizeWords(item.adr)}</label>
                                </div>
                            ))}
                        </div>
                    )}

                    {cargarfiltros === false || mostraradr === false ? (
                        <div></div>
                    ) : (
                        <div className="filtro-periodo">
                            <div className="title title-adr">Periodo</div>
                            {Meses.map((item, index) => (
                                <div key={item.idMes} className="chk-groups">
                                    <input
                                        type="checkbox"
                                        name="chk-periodo"
                                        onChange={(e) => selectedClick(e, index)}
                                        checked={item.checked} // Asegúrate de que esta propiedad existe
                                        value={item.idMes}
                                    />
                                    <label>{capitalizeWords(item.nombre)}</label>
                                </div>
                            ))}
                        </div>
                    )}

                    {cargarfiltros === false || mostrarsucursal === false ? (
                        <div></div>
                    ) : (
                        <div className="filtro-sucursal">
                            <div className="title">Sucursal</div>
                            {sucursal.map((item, index) => (
                                <div key={`${item}-${index}`} className="chk-groups">
                                    <input
                                        type="checkbox"
                                        name="chk-sucursal"
                                        className="my-checkbox"
                                        onChange={(e) => selectedClick(e, index)}
                                        checked={item.checked}
                                        value={item.idsucursal}
                                    />
                                    <label onClick={labelclick}>{capitalizeWords(item.sucursal)}</label>
                                </div>
                            ))}
                        </div>
                    )}
                    {cargarfiltros === false || mostrardepartamento === false ? (
                        <div></div>
                    ) : (
                        <div className="filtro-departamento">
                            <div className="title">Departamento</div>
                            {departamento.map((item, index) => (
                                <div key={`${item}-${index}`} className="chk-groups">
                                    <input
                                        type="checkbox"
                                        name="chk-departamento"
                                        onChange={(e) => selectedClick(e, index)}
                                        checked={item.checked}
                                        value={item.iddepartamento}
                                    />
                                    <label>{capitalizeWords(item.departamento)}</label>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};
